export default {
    "entityTagViewer_units": "Ver por Unidad",
    "entityTagViewer_drivers": "Ver por Conductor",
    "entityTagViewer_landmarks": "Ver por Punto de Referencia",
    "entityTagViewer_geofences": "Ver por Geocerca",
    "entityTagViewer_forms": "Ver por Formulario",
    "entityTagViewer_users": "Ver por Usuario",
    "entityTagViewer_tag": "Ver por Etiqueta",
    "entityTagViewer_notFound": "No se encontraron elementos",
}